import { CategoryHierarchy } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';
import { LoadCategoryProps } from 'composables/src/types';

export async function loadCategory(
  context: Context,
  params: LoadCategoryProps
): Promise<CategoryHierarchy[]> {

  const categoryHierarchy = await context.$sapcc.api.getCategory(params);

  return [categoryHierarchy];
}
